var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[_c('div',[_c('settlements-report-filter',{attrs:{"action":_vm.filterAction,"exportExcel":_vm.exportToExcel}}),_c('div',[_c('kt-datatable',_vm._b({ref:"datatable"},'kt-datatable',_vm.datatableProps,false))],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }